export default __webpack_public_path__ + "static/media/dispute.a12c5354.svg";